import { Http } from '@/lib/http';

export class incomeAndExpenseTypeService extends Http {
  constructor() {
    super();
    this.endPoint = 'onboarder/settings/income-and-expenditure-types';
  }

  getIncAndExpTypes() {
    return this.httpClient().get(this.endPoint);
  }

  createIncAndExpTypes(incomeAndExpenseType) {
    return this.httpClient().post(this.endPoint, incomeAndExpenseType);
  }

  updateIncAndExpType(id, incomeAndExpenseType) {
    return this.httpClient().patch(
      `${this.endPoint}/${id}`,
      incomeAndExpenseType
    );
  }
}
